<template>
  <div class="tab-wrapper">
    <table-list 
      :columns="columns"
      :data="tableData"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
      >
      <Button type="primary" class="btn mb16 fr" @click="createWhiteList" v-p="{api:'specialRule/add'}">添加</Button>
    </table-list>
    <add-modal :n="addKey" @refresh="refresh"></add-modal>
    <close-modal :n="closeKey" :title="'关闭虚拟抵扣'" :action="'此操作'" @cancel="close"></close-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import TableList from 'components/TableList/index';
import CloseModal from 'components/CancelModal/index';
import AddModal from './components/AddModal';
import {getPageList,closeSpecialRules} from '@/api/managementCenter'

export default {
  // created(){
  //   this.getList(1)
  // },
  props:{
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(val){
      this.getList(1)
    }
  },
  components: {
    TableList,
    AddModal,
    CloseModal

  },
  data() {
    return {
      loading:false,
      current:1,
      total:0,
      limit:10,
      addKey:0,
      closeKey:0,
      fid:null,
      columns:[
       {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title:'合同号',
          key:'contractCode',
          align: 'center'
        },
        {
          title:'项目名称',
          key:'projectName',
          align: 'center'
        },
        {
          title:'更新时间',
          key:'updateTime',
          align: 'center'
        },
        {
          title:'状态',
          key:'ruleStatusName',
          align: 'center',
          render:  (h,params) => {
            return h('span',{
              'class':{
                'info-color':params.row.ruleStatus === 1,
                'success-color':params.row.ruleStatus === 0,
                'sub-color':params.row.ruleStatus === 2,
              }
             
            },
            params.row.ruleStatusName
            )
          }
        },
        {
          title:'操作人',
          key:'oper',
          align: 'center'
          
        },
        {
          title:'操作',
          key:'action',
          align: 'center',
          render: (h,params) => {
            return h('a',{
              directives:[
                {
                  name:'p',
                  value:{
                    api:'specialRule/cancel'
                  }
                }
              ],
              style:{
                display: params.row.ruleStatus === 0 ?'inline-block' : 'none'
              },
              on: {
                click: () =>{
                  this.fid = params.row.fid
                  this.closeKey++
                }
              }
            },'关闭')
          }
        }
      ],
      tableData:[]
    }
  },
  methods:{
    createWhiteList(){
      this.addKey++
    },
    close(){
     closeSpecialRules(this.fid).then(res => {
        this.$Message.success('关闭成功！')
        this.refresh()
      })
    },
    changPage(n){
      this.current = n
      this.getList(n)
    },
    getList(n){
      let data = {
        limit:10,
        page:n,
        ruleType:3
      }
      this.loading = true
      getPageList(data).then( res => {
        this.total = res.data.total
        this.tableData = res.data.list
        this.loading = false
       
      }).catch( err => {
        this.loading = false
        console.log(err)
      })
    },
    refresh(){
      this.current = 1
      this.getList(1)
    }
  }
}
</script>
